import { createElement } from 'react';

import './index.scss';

export const StrokedText = ({ tag = 'strong', text, ...otherProps }) => createElement(tag, { ...otherProps, className: 'stroked-text' }, text);
